import type { VDataTableServer } from 'vuetify/components';
export enum PaginationDirectionEnum {
  ASC = 'ASC',
  DESC = 'DESC',
}

export interface IPaginationDTO {
  limit: number;
  skip: number;
  q: string;
  orderBy: string;
  orderDirection: PaginationDirectionEnum;
  exclude: unknown;
  buildPagination(value: VDataTableServer): void;
}

export class PaginationDTO implements IPaginationDTO {
  limit: number;
  skip: number;
  q: string;
  orderBy: string;
  orderDirection: PaginationDirectionEnum;
  exclude: unknown;

  constructor(
    limit: number = 10,
    skip: number = 1,
    q: string = '',
    orderBy = '',
    orderDirection = PaginationDirectionEnum.DESC,
  ) {
    this.limit = limit;
    this.skip = skip;
    this.q = q;
    this.orderBy = orderBy;
    this.orderDirection = orderDirection;
    this.exclude = {};
  }

  buildPagination(value: VDataTableServer): void {
    this.limit = parseInt(value.itemsPerPage.toString());
    if (value.sortBy.length > 0) {
      this.orderBy = value.sortBy[0].key ?? '';
      this.orderDirection =
        value.sortBy[0].order === 'desc'
          ? PaginationDirectionEnum.DESC
          : PaginationDirectionEnum.ASC;
    } else {
      this.orderBy = 'modified_on';
      this.orderDirection = PaginationDirectionEnum.DESC;
    }
    this.q = value.search ?? '';
    this.skip = parseInt(value.page.toString());
  }
}
